import { useSelector } from 'react-redux'

import { selectRouteParams } from 'core-components/sitebuilder/store/selectors/selectRouteParams'

import { ContactListTab } from '../../contactListTab/ContactListTab'

import { COLUMNS, IGNORED_FIELDS } from './configs'
import { useProfilingTeamRequestSource } from './hooks/useProfilingTeamRequestSource'
import { IProfilingTeamRequestTabProps } from './models'

export const ProfilingTeamRequestTab = (props: IProfilingTeamRequestTabProps) => {
  const routeParams = useSelector(selectRouteParams)

  const isPartner360Page = routeParams.page === 'jbl-hpscoutso'

  return (
    <ContactListTab
      {...props}
      useSource={useProfilingTeamRequestSource}
      columns={COLUMNS}
      ignoredFields={IGNORED_FIELDS}
      isPartner360Page={isPartner360Page}
    />
  )
}
